<template>
  <div class="ivu-shrinkable-menu">
    <slot name="logo"></slot>
    <sidebar-menu
      v-if="!shrink"
      :menu-lists="menuLists"
      :open-names="openNames"
      @changeSQ="changeSQ"
    ></sidebar-menu>
    <sidebar-menu-shrink
      @changeZK="changeZK"
      v-else
      :menu-lists="menuLists"
      :open-names="openNames"
    ></sidebar-menu-shrink>
  </div>
</template>

<script>
import sidebarMenu from '@/components/sidebar-menu/sidebar-menu'
import sidebarMenuShrink from '@/components/sidebar-menu/sidebar-menu-shrink'

export default {
  props: {
    shrink: {
      type: Boolean,
      default: false,
    },

    menuLists: {
      type: Array,
    },

    openNames: {
      type: Array,
    },
  },
  //   data() {
  //     return {
  //       shrink: false,
  //     }
  //   },
  methods: {
    changeSQ() {
      this.$emit('changeSQ', false)
    },
    changeZK() {
      this.$emit('changeZK', true)
    },
  },

  components: {
    sidebarMenu,
    sidebarMenuShrink,
  },
}
</script>

<style lang="scss">
@import '../../resources/scss/sidebar-menu/menu';
</style>


// WEBPACK FOOTER //
// src/components/sidebar-menu/shrinkable-menu.vue